import { PartitionOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { FC, ReactNode } from 'react';
import './layout.scss';

/* -------------------------------------------------------------------------------- *\
|                               LayoutSite
\* -------------------------------------------------------------------------------- */
export const LayoutSite: FC<{ children?: ReactNode }> = (children) =>
{
	return (
		<div className="layout">
			<div className="layout__sider" >
				<div className="layout__logo">
				<a href="/" ><img src={'/images/logo.png'} alt="McLloyd" /></a>
				</div> 
				<div className="layout__menucont">
					<div className="layout__menu">
						<Tooltip title="Datas" placement='right' color={'#888888'}><a className='layout__menu__item' href="/datas" ><PartitionOutlined /></a></Tooltip>
					</div>
				</div>
			</div>
			<div className="layout__content">
				<div className="layout__content__inner">
					<div>{children.children}</div>
					<div className="layout__footer">WebHook @mclloyd 2025{process.env.REACT_APP_VERSION ? ` - version ${process.env.REACT_APP_VERSION}` : ''}</div>
				</div>
			</div>
	  </div>
	  );
}